import { useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import { DraggableModalDialog } from '../DraggableModalDialog';
import { Button, Modal, Row, Col, Card } from 'react-bootstrap';
import exxonLogo from '../../../Images/exxon_logo.png';
import jemmacLogo from '../../../Images/jemmac_logo.png';

import { useListPrivileges } from '../../../hooks/usePrivileges';
import { useListActiveDirectoryGroups } from '../../../hooks/useActiveDirectoryGroups';

function AboutDlg(props) {

    AboutDlg.propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggleModal: PropTypes.func.isRequired,
        version: PropTypes.string.isRequired
    }

    const { accounts } = useMsal();
    const name = accounts[0] && accounts[0].name;
    const username = accounts[0] && accounts[0].username;

    const { privileges, loading } = useListPrivileges();

    const { activeDirectoryGroups, loadingADGroups } = useListActiveDirectoryGroups();

    return (
        <Modal dialogAs={DraggableModalDialog} show={props.isOpen} onHide={props.toggleModal} backdrop="static" size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    About Cert App
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>The Cert App software suite is the property of ExxonMobil Corporation. You are responsible for reading the disclaimer below:</p>
                <Card>
                    <Card.Body>
                        <p>Access is restricted to those specifically authorized by ExxonMobil Corporation and its affiliates ("Company"), and is to be used solely for Company-authorized purposes. This system has security facilities to prevent and record unauthorized access attempts.</p>
                        <p>Your authorization to access this system is contingent upon your acknowledgement that ALL FILES, DATA, ELECTRONIC MESSAGES, PROGRAMS, AND OTHER STORED ITEMS PLACED ON THIS SYSTEM BELONG TO THE COMPANY. The Company is likely to examine activity and stored items to the fullest extent permitted by law.</p>
                        <p>Your authorization to access this system is also contingent upon your acceptance of the legal obligation not to use the system in a way that would violate any law or that would be inconsistent with Company policies or standards including those on Ethics, Harassment, Conflict of Interest or Systems Security.</p>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body>
                        <Row>
                            <Col xs={3}>
                                <p>Cert App Version:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{props.version}</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>About User:</p>
                            </Col>
                            <Col xs={9}>
                                <p>{name}, ({username})</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>Privileges:</p>
                            </Col>
                            <Col xs={9}>
                                {loading
                                    ? <p className="fst-italic">Getting privileges...</p>
                                    : <p>{privileges && privileges.join(', ')}</p>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <p>AD Groups: </p>
                            </Col>
                            <Col xs={9}>
                                {loadingADGroups
                                    ? <p className="fst-italic">Getting AD Groups...</p>
                                    : <p>{activeDirectoryGroups && activeDirectoryGroups.join(', ')}</p>
                                }
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <p className="text-center">Developed as a joint effort by ExxonMobil Quality Management and Jemmac Software Ltd under contract to ExxonMobil.</p>
                <Row>
                    <Col>
                        <img src={exxonLogo} alt="ExxonMobil logo" className="d-flex justify-content-end me-3" />
                    </Col>
                    <Col>
                        <img src={jemmacLogo} alt="Jemmac logo" />
                    </Col>
                </Row>
                <p className="text-center">{props.copywrite}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button color="primary" onClick={props.toggleModal}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AboutDlg;